import { z } from "zod";
export const acquisitionSettingsUpdateSchema = z
    .object({
    warehouseUf: z.literal("SP"),
    regime: z.enum(["NON_CUMULATIVE", "CUMULATIVE", "UNKNOWN"]),
    creditEligibility: z.enum(["ELIGIBLE", "INELIGIBLE", "UNCONFIRMED"]),
    validFrom: z.string().date(),
    validTo: z.string().date().nullable(),
    confirmationReference: z.string().trim().min(10).max(1000),
})
    .strict()
    .superRefine((value, context) => {
    if (value.validTo !== null && value.validTo < value.validFrom) {
        context.addIssue({
            code: "custom",
            path: ["validTo"],
            message: "End date precedes start date",
        });
    }
    if (value.regime !== "NON_CUMULATIVE" && value.creditEligibility === "ELIGIBLE") {
        context.addIssue({
            code: "custom",
            path: ["creditEligibility"],
            message: "Ordinary acquisition contribution credits require the non-cumulative regime",
        });
    }
});
export const acquisitionSettingSchema = z
    .object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    revision: z.number().int().positive(),
    warehouseUf: z.literal("SP"),
    regime: z.enum(["NON_CUMULATIVE", "CUMULATIVE", "UNKNOWN"]),
    creditEligibility: z.enum(["ELIGIBLE", "INELIGIBLE", "UNCONFIRMED"]),
    validFrom: z.string().date(),
    validTo: z.string().date().nullable(),
    confirmationReference: z.string().min(10).max(1000),
    confirmedBy: z.string().uuid(),
    confirmedAt: z.string().datetime(),
    contentSha256: z.string().regex(/^[a-f0-9]{64}$/),
})
    .strict();
export const acquisitionSettingsSchema = z
    .object({
    revision: z.number().int().nonnegative(),
    setting: acquisitionSettingSchema.nullable(),
})
    .strict();
//# sourceMappingURL=acquisition-settings.js.map